module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_5.c587933c.png";